import React from 'react';
import styled from 'styled-components';
import { Icon, Text } from '../';
import { colors } from '../../../stylesheets';

type Props = {
  title: string,
  iconName?: string,
  className?: string,
  textSize?: 'xl' | 'lg' | 'mdb' | 'md' | 'sm' | 'xs',
};

const StyledTag = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
  min-width: 110px;
  background: ${colors.primaryText};
`;

const Tag = ({ iconName, title, className, textSize }: Props) => {
  return (
    <StyledTag className={`${className} ${!iconName ? 'pr-2' : 'pr-1'} pl-2`}>
      {iconName && <Icon name={iconName} color={'primary'} />}
      <Text className="mr-1" color={'primary'} size={textSize}>
        {title}
      </Text>
    </StyledTag>
  );
};

Tag.defaultProps = {
  textSize: 'sm',
  className: '',
};

export default Tag;
